import {
	ActionRestrictionsTypes,
	SET_RESTRICTIONS,
	SET_RESTRICTIONS_LOADING,
	SET_RESTRICTIONS_ACCEPTED
} from './actions';
import { RestrictionsState } from './types';

const initialState: RestrictionsState = {
	restrictions: [],
	loading: false,
	accepted: false
};

function restrictionsReducer(state = initialState, { type, payload }: ActionRestrictionsTypes) {
	switch (type) {
		case SET_RESTRICTIONS:
			return {
				...state,
				restrictions: payload
			};
		case SET_RESTRICTIONS_LOADING:
			return {
				...state,
				loading: payload
			};
		case SET_RESTRICTIONS_ACCEPTED:
			return {
				...state,
				accepted: payload
			};
		default:
			return state;
	}
}

export default restrictionsReducer;
